import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ad-plans',
  templateUrl: './ad-plans.component.html',
  styleUrls: ['./ad-plans.component.css']
})
export class AdPlansComponent implements OnInit {

  constructor(private dataService: DataService, private _notification: MatSnackBar) { }

  planData: FormGroup = new FormGroup({
    plan: new FormControl('', [Validators.required]),
    price: new FormControl('', [Validators.required]),
    validityDays: new FormControl('', [Validators.required]),
  })

  submitPlanData(data:any){
  	this.dataService.submitPropertyPlan(data)
      .subscribe( response => {
        if(response.status){
          this.openNotification('Plan has been added')
          this.planData.reset()
          Object.keys(this.planData.controls).forEach(key => {
            this.planData.get(key).setErrors(null) ;
          });
        }
      });
  }

  ngOnInit(): void {
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
